<script type="text/jsx">
import SparklesIcon from '../../assets/sparkles.png';
import { t } from '../../plugins/i18n.js';
import { showDialog } from '@/utils/export';
import { MEETING_DEFAULT_CMR_CAPACITY, PLAN_TYPES } from '@/components/planConst';
import AutoExpireBadge from '@/components/AUTO_EXPIRE_BADGE';
import { BADGE_ID_MAPPER } from '@/datas/auto-expire-badge';
import { isEnableEssentialApps } from '@/utils/toggle'

export default {
  components: {
    AutoExpireBadge
  },
  props: {
    onEssentialAppLearnMore: Function,
    onAICompanionLearnMore: Function,
    onTasksLearnMore: Function,
    onCustomAvatarLearnMore: Function,
    showStartingPrice: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    async openWorkFlowLearnMore() {
      await showDialog(await import(/* webpackChunkName: "zoom_work_flow_automation_dialog" */ '@/components/ZOOM_WORK_FLOW_AUTOMATION_DIALOG'), { visible: true })
    },
    async openDriveLearnMore() {
      await showDialog(await import(/* webpackChunkName: "PLAN_LEARN_MORE_DIALOG" */ '@/components/PLAN_LEARN_MORE_DIALOG'), { visible: true, planType: PLAN_TYPES.DRIVE })
    }
  },
  render() {
    const enableEssentialApps = isEnableEssentialApps();
    return (
      <ul class="zone-detail-dialog__feature">
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{t('fbc.plan_details.biz_plus.meetings')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{t('fbc.plan_details.pro_plus.host_meeting_up_to_participants', [100])}</li>
            <li>{t('fbc.plan_details.biz_plus.unlimited_meetings_for_up_to_30_hours_per_meeting')}</li>
            <li>{t('fbc.plan_details.pro_plus.gb_of_cloud_recording_storage', [MEETING_DEFAULT_CMR_CAPACITY.PRO_PLUS])}</li>
            <li>{t('fbc.plan_details.biz_plus.auto_translated_captions')}</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2
            class="zone-detail-dialog__feature-title first-capitalize">{t('fbc.plan_details.biz_plus.whiteboard.title')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{t('fbc.plan_details.pro_plus.standard_features', [3, 25])}</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2
            class="zone-detail-dialog__feature-title first-capitalize">{t('fbc.plan_details.biz_plus.team_chat.title')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{t('fbc.plan_details.biz_plus.chats_channels_for_collaboration')}</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item">
          <h2
            class="zone-detail-dialog__feature-title first-capitalize">{t('fbc.plan_details.biz_plus.mail_calender.title')}</h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{t('fbc.plan_details.biz_plus.mail_and_calendar_client_and_services_beta')}</li>
          </ul>
        </li>
        {!window.newBillingConfig?.disabledClips && (
          <li class="zone-detail-dialog__feature-item">
            <h2 class="zone-detail-dialog__feature-title first-capitalize">
              {t('fbc.plan_details.biz_plus.clips_plus')}
            </h2>
            <ul class="zone-detail-dialog__feature-item-list">
              <li>{t('fbc.plan_details.biz_plus.easily_record_edit_share_videos')}</li>
              <li>{t('fbc.plan_details.biz_plus.unlimited_videos_advanced_features')}</li>
            </ul>
          </li>
        )}
        {window.newBillingConfig.isEligibleAccount4CustomAvatarFeature && (
          <li class="zone-detail-dialog__feature-item">
            <h2 class="zone-detail-dialog__feature-title first-capitalize">
              <auto-expire-badge badgeId={BADGE_ID_MAPPER.CUSTOM_AVATAR} theme="feature" style="margin-right: 4px;" />
              { t('fbc.plan_details.custom_avatar.title') }
            </h2>
            <ul class="zone-detail-dialog__feature-item-list">
              <li>{ t('fbc.plan_details.custom_avatar.features_item1_opc') }</li>
              <li>{ t('fbc.plan_details.custom_avatar.features_item2_opc') }</li>
              {/* <zm-button
                data-testid="common-button-46"
                type="link"
                class="zone-detail-dialog__link"
                onClick={this.onCustomAvatarLearnMore}
                aria-label="Learn More about Zoom Tasks"
              >
                {t('fbc.plan_details.biz_plus.learn_more')}
              </zm-button> */}
            </ul>
          </li>
        )}
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">
            {t('fbc.plan_details.biz_plus.notes')}
          </h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{t('fbc.plan_details.biz_plus.create_share_editabel_docu_within_zoom')}</li>
            <li>{t('fbc.plan_details.biz_plus.personal_collaborative_notes_rich_text_editing')}</li>
          </ul>
        </li>
        <li class="zone-detail-dialog__feature-item ai-companion-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">
            {t('fbc.plan_details.biz_plus.ai_companion')}
            <img src={SparklesIcon} class="zone-detail-dialog__feature-title__icon" />
          </h2>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{t('fbc.plan_details.biz_plus.automate_key_tasks')}</li>
            <li>
              {t('fbc.plan_details.biz_plus.gain_quick_access_to_meeting_summaries')}
              <br />
              <zm-button
                data-testid="common-button-47"
                type="link"
                class="zone-detail-dialog__link"
                onClick={this.onAICompanionLearnMore}
                aria-label="Learn More about AI Companion"
              >
                {t('fbc.plan_details.biz_plus.learn_more')}
              </zm-button>
            </li>
          </ul>
        </li>
        {window.newBillingConfig.enableDocsFeature && (
          <li class="zone-detail-dialog__feature-item">
            <h2 class="zone-detail-dialog__feature-title first-capitalize">
              { t('fbc.plan_details.biz_plus.docs.docs') }
            </h2>
            <ul class="zone-detail-dialog__feature-item-list">
              <li>{ t('fbc.plan_details.biz_plus.docs.features_item1') }</li>
              <li>{ t('fbc.plan_details.biz_plus.docs.features_item2') }</li>
              <li>{ t('fbc.plan_details.biz_plus.docs.features_item3') }</li>
            </ul>
          </li>
        )}
        {window.newBillingConfig.enableDisplayZoomTasksWithoutAccountCheck && (
          <li class="zone-detail-dialog__feature-item">
            <h2 class="zone-detail-dialog__feature-title first-capitalize">
              <auto-expire-badge badgeId={BADGE_ID_MAPPER.TASKS} theme="feature" style="margin-right: 4px;" />
              { t('fbc.plan_details.biz_plus.tasks.tasks') }
            </h2>
            <ul class="zone-detail-dialog__feature-item-list">
              <li>{ t('fbc.plan_details.biz_plus.tasks.features_item1_opc') }</li>
              <li>{ t('fbc.plan_details.biz_plus.tasks.features_item2_opc') }</li>
              <zm-button
                data-testid="common-button-48"
                type="link"
                class="zone-detail-dialog__link"
                onClick={this.onTasksLearnMore}
                aria-label="Learn More about Zoom Tasks"
              >
                {t('fbc.plan_details.biz_plus.learn_more')}
              </zm-button>
            </ul>
          </li>
        )}
        {window.newBillingConfig.enableDisplayZoomWorkFlow && (
          <li class="zone-detail-dialog__feature-item">
            <h2 class="zone-detail-dialog__feature-title first-capitalize">
              <auto-expire-badge badgeId={BADGE_ID_MAPPER.WORKFLOW_AUTOMATION} theme="feature" style="margin-right: 4px;" />
              { t('billing.plan.feature.workflow.title') }
            </h2>
            <ul class="zone-detail-dialog__feature-item-list">
              <li>{ t('billing.plan.feature.workflow.desc_ai') }</li>
              <li>{ t('billing.plan.feature.workflow.desc_doc') }</li>
              <zm-button
                data-testid="common-button-49"
                type="link"
                class="zone-detail-dialog__link"
                onClick={this.openWorkFlowLearnMore}
                aria-label="Learn More about Zoom WorkFlow"
              >
                {t('fbc.plan_details.biz_plus.learn_more')}
              </zm-button>
            </ul>
          </li>
        )}
        {window.newBillingConfig.enableDisplayZoomDrive && (
          <li class="zone-detail-dialog__feature-item">
            <h2 class="zone-detail-dialog__feature-title first-capitalize">
              <auto-expire-badge badgeId={BADGE_ID_MAPPER.DRIVE} theme="feature" style="margin-right: 4px;" />
              { t('billing.plan.feature.drive.title') }
            </h2>
            <ul class="zone-detail-dialog__feature-item-list">
              <li>{ t('billing.plan.feature.drive.feature1') }</li>
              <li>{ t('billing.plan.feature.drive.feature2') }</li>
              <li>{ t('billing.plan.feature.drive.features_item3') }</li>
              <zm-button
                data-testid="common-button-50"
                type="link"
                class="zone-detail-dialog__link"
                onClick={this.openDriveLearnMore}
                aria-label="Learn More about Zoom Hub"
              >
                {t('fbc.plan_details.biz_plus.learn_more')}
              </zm-button>
            </ul>
          </li>
        )}
        {
          enableEssentialApps && (
            <li class="zone-detail-dialog__feature-item">
              <h2
                class="zone-detail-dialog__feature-title first-capitalize">{t('fbc.plan_details.biz_plus.essential_apps')}</h2>
              <ul class="zone-detail-dialog__feature-item-list">
                <li>{t('fbc.plan_details.biz_plus.free_premium_apps')}</li>
                <li>
                  {t('fbc.plan_details.biz_plus.increase_team_collaboration')}
                  <br />
                  <zm-button
                    data-testid="common-button-51"
                    type="link"
                    class="zone-detail-dialog__link"
                    onClick={this.onEssentialAppLearnMore}
                    aria-label="Learn More about Essential Apps"
                  >
                    {t('fbc.plan_details.biz_plus.learn_more')}
                  </zm-button>
                </li>
              </ul>
            </li>
          )
        }
        <li class="zone-detail-dialog__feature-item">
          <h2 class="zone-detail-dialog__feature-title first-capitalize">{t('fbc.plan_details.biz_plus.phone')}</h2>
          <span
            class="required zone-detail-dialog__feature-subtitle">{t('fbc.plan_details.biz_plus.zoom_phone_is_biz_use_only')}</span>
          <ul class="zone-detail-dialog__feature-item-list">
            <li>{t('fbc.plan_details.biz_plus.unlimited_regional_calling')}</li>
            <li>{t('fbc.plan_details.biz_plus.domestic_sms_mms')}</li>
            <li>{t('fbc.plan_details.biz_plus.automatic_call_distribution_groups')}</li>
          </ul>
        </li>
      </ul>
    );
  },
};
</script>

<style>
.zm-theme--dark {
  --dark-text-color: #f7f9fa;
  --dark-text-color2: #98a0a9;
}
</style>

<style lang="scss" scoped>
.first-capitalize {
  &::first-letter {
    text-transform: capitalize;
  }

  *::first-letter {
    text-transform: capitalize;
  }
}

.required {
  &::before {
    content: '*';
  }
}

.zone-detail-dialog {
  &__feature {
    &-title {
      color: var(--dark-text-color, #00053D);
      font-family: Almaden Sans;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%; /* 21px */
      letter-spacing: 0.14px;
      display: flex;
      flex-direction: row;
      align-items: center;

      &__icon {
        width: 16px;
        height: 16px;
        font-size: 0;
        margin-left: 4px;
      }
    }

    &-item {
      position: relative;
      padding-left: 20px;
      margin-bottom: 16px;

      &::before {
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        background-image: url('../../assets/Vector.svg');
        background-repeat: no-repeat;
        background-size: cover;
        width: 16px;
        height: 21px;
        font-size: 20px;
        font-weight: 700;
      }

      &-list {
        list-style: disc;
        padding-left: 14px;
        li {
          &::marker {
            color: var(--dark-text-color, #00053D);
          }

          &::first-letter {
            text-transform: capitalize;
          }

          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          line-height: 150%;
          color: var(--dark-text-color2, #00053D);
        }
      }
    }

    &-subtitle {
      color: var(--dark-text-color, #515079);
      font-family: Almaden Sans;
      font-size: 12px;
      font-style: italic;
      font-weight: 400;
      line-height: 150%;
      letter-spacing: 0.12px;
    }

    &-end {
      display: flex;
      padding: 8px 12px;
      align-items: flex-start;
      border-radius: 8px;
      background: #F2F2F4;
      margin-top: 16px;
    }
  }
}
</style>
